{
  "&": "& ",
  "demo": "This is a demo version of Rehla. Data altering actions will not work.",
  "agency": {
    "addPhoneNumber": "Add phone number",
    "benefits": {
      "analytics": {
        "description": "Track bookings, revenue, and performance metrics in real-time",
        "title": "Analytics & Insights"
      },
      "clients": {
        "description": "Build lasting relationships with your clients",
        "title": "Manage Clients"
      },
      "subtitle": "Get started in minutes and grow your travel business with powerful tools designed for agencies like yours.",
      "team": {
        "description": "Collaborate with your team and assign roles",
        "title": "Team Management"
      },
      "title": "What you can do",
      "trips": {
        "description": "Create and manage trips with ease, set pricing, and track capacity",
        "title": "Organize Trips"
      }
    },
    "create": {
      "error": {
        "description": "Could not create your agency. Please try again.",
        "imageUpload": "Logo upload failed"
      },
      "success": {
        "description": "Agency created successfully."
      }
    },
    "description": "Description",
    "empty": {
      "filters": {
        "description": "Try adjusting your filters or clear them to see all agencies.",
        "title": "No agency matches your filters"
      },
      "noFilters": {
        "description": "The agency you're looking for doesn't exist or may have been removed.",
        "title": "Agency not found"
      },
      "title": "Agency not found"
    },
    "error": {
      "description": "We encountered an error while loading this agency. Please try again."
    },
    "forbidden": {
      "description": "You are not allowed to view this agency. Contact your administrator if you think this is an error."
    },
    "logo": {
      "current": {
        "description": "Your current agency logo",
        "title": "Current logo"
      },
      "error": {
        "invalidType": {
          "description": "Please select only image files (JPEG, PNG, or WebP)",
          "title": "Invalid file type"
        }
      },
      "logo": "Logo",
      "new": {
        "description": "Upload your agency logo (max 10MB)",
        "title": "Drag logo here or click to select file"
      },
      "update": {
        "description": "Upload a new logo to replace the current one (max 10MB)",
        "title": "Drag new logo here or click to select file"
      }
    },
    "name": "Agency name",
    "new": "New agency",
    "phone": "Phone number",
    "save": "Create agency",
    "subtitle": "Set up your agency profile to start managing trips and clients",
    "title": "Create Your Agency",
    "username": {
      "description": "5 characters, numbers and letters only",
      "error": {
        "usernameAvailable": "Username is already taken"
      },
      "title": "Agency username"
    },
    "website": "Website"
  },
  "all": "All",
  "amount": "Amount",
  "analytics": {
    "clients": {
      "acquisitionTimeline": "Client acquisition timeline",
      "heavy": "Heavy",
      "heavyDescription": "6+ bookings",
      "light": "Light",
      "lightDescription": "0-2 bookings",
      "medium": "Medium",
      "mediumDescription": "3-5 bookings",
      "newClients": "New",
      "newVsReturning": "New vs returning clients",
      "noOutstandingDues": "No clients with outstanding dues",
      "outstandingDues": "Clients with outstanding dues",
      "returningClients": "Returning",
      "segmentation": "Client segmentation",
      "title": "Client Analytics",
      "topBySpend": "Top clients by spend"
    },
    "dateRange": {
      "allTime": "All time",
      "clearCustom": "Clear custom range",
      "custom": "Custom",
      "customRange": "Custom range",
      "lastThreeMonths": "Last 3 months",
      "thisMonth": "Last month",
      "thisYear": "Last year"
    },
    "error": {
      "description": "Error loading analytics. Please try again."
    },
    "forbidden": {
      "description": "You are not allowed to view analytics. Contact your administrator if you think this is an error."
    },
    "noData": "No data",
    "overview": {
      "activeTrips": "Active trips",
      "amountDue": "Amount due",
      "newClients": "New clients",
      "newClientsThisMonth": "New clients this month",
      "overview": "Overview",
      "totalClients": "Total clients",
      "totalRefunds": "Total refunds",
      "totalReservations": "Total reservations",
      "totalRevenue": "Total revenue"
    },
    "payments": {
      "completionRate": "Payment completion rate",
      "fullyPaid": "Fully paid",
      "overpaid": "Overpaid reservations",
      "overrefunded": "Overrefunded reservations",
      "partialPayments": "Partial payments",
      "title": "Payment Analytics",
      "totalDue": "Total amount due",
      "totalPaid": "Total amount paid",
      "totalRefunded": "Total refunded"
    },
    "reservations": {
      "adults": "Adults",
      "averageRevenue": "Average revenue per reservation",
      "averageTimeBetweenBookingAndTrip": "Average time between booking and trip",
      "cancellationRate": "Cancellation rate",
      "cancellations": "Cancellations",
      "cancelled": "Cancelled",
      "cancelledWithRefund": "With refund",
      "cancelledWithoutRefund": "Without refund",
      "children": "Children",
      "composition": "Reservation composition",
      "days": "days",
      "overTime": "Reservations over time",
      "reservations": "Reservations",
      "revenue": "Revenue",
      "revenueOverTime": "Revenue over time",
      "statusDistribution": "Status distribution",
      "title": "Reservations Analytics"
    },
    "title": "Analytics",
    "trips": {
      "accessibilityDistribution": "Accessibility distribution",
      "audienceDistribution": "Audience distribution",
      "foodDistribution": "Food options distribution",
      "guidesDistribution": "Guides distribution",
      "lowCapacity": "Low capacity trips",
      "noLowCapacityTrips": "No trips with low capacity",
      "noTripsStartingSoon": "No trips starting in the next 30 days",
      "overbooked": "Overbooked",
      "peakTravelMonths": "Peak travel months",
      "remaining": "remaining",
      "startingSoon": "Trips starting soon",
      "title": "Trip Analytics",
      "topByReservations": "Top trips by reservations",
      "topByRevenue": "Top trips by revenue",
      "transportationDistribution": "Transportation distribution"
    }
  },
  "auditLog": {
    "action": "Action",
    "actions": {
      "CREATE": "created",
      "DELETE": "deleted",
      "UPDATE": "updated"
    },
    "date": "Date",
    "empty": {
      "filters": {
        "description": "Try adjusting your filters or clear them to see all audit logs.",
        "title": "No audit logs match your filters"
      },
      "noFilters": {
        "description": "Actions performed by users will appear here.",
        "title": "No audit logs yet"
      }
    },
    "error": {
      "description": "We encountered an error while loading audit logs. Please try again."
    },
    "exportPDF": {
      "all": {
        "button": "Export All",
        "empty": "No audit log entries found to export.",
        "error": {
          "description": "Could not export audit log to PDF. Please try again."
        },
        "success": {
          "description": "Audit log exported to PDF successfully."
        }
      }
    },
    "filters": {
      "action": "Action",
      "dateRange": "Date Range",
      "model": "Entity",
      "userType": "User Type"
    },
    "forbidden": {
      "description": "You are not allowed to view audit logs. Only owners can access this feature."
    },
    "model": "Entity",
    "models": {
      "AGENCY": "the agency",
      "CLIENT": "a client",
      "DISCOUNT_CODE": "a discount code",
      "EMPLOYEE": "an employee",
      "PAYMENT": "a payment",
      "RESERVATION": "a reservation",
      "ROLE": "a role",
      "TRIP": "a trip",
      "WITHDRAWAL": "a withdrawal"
    },
    "new": "New audit log",
    "title": "Audit Log",
    "user": "User",
    "userTypes": {
      "employee": "Employee",
      "owner": "Owner"
    },
    "viewAll": "View all"
  },
  "back": "Back",
  "cancel": "Cancel",
  "changeLanguage": "Change Language",
  "client": {
    "empty": {
      "filters": {
        "description": "Try adjusting your filters or clear them to see all clients.",
        "title": "No client matches your filters"
      },
      "noFilters": {
        "description": "The client you're looking for doesn't exist or may have been removed.",
        "title": "Client not found"
      }
    },
    "error": {
      "description": "We encountered an error while loading this client. Please try again."
    },
    "forbidden": {
      "description": "You are not allowed to view this client. Contact your administrator if you think this is an error."
    },
    "new": "New client"
  },
  "clients": {
    "client": "Client",
    "clients": "Clients",
    "create": {
      "error": {
        "description": "Could not create your client. Please try again."
      },
      "success": {
        "description": "Client created successfully."
      }
    },
    "detail": {
      "clientInfo": "Client information",
      "emailVerified": "Email verified",
      "phoneVerified": "Phone number verified",
      "reservations": "Reservations",
      "statistics": "Statistics"
    },
    "edit": {
      "edit": "Edit client",
      "error": {
        "description": "Could not edit your client. Please try again.",
        "phoneExists": "A client with this phone number already exists"
      },
      "success": {
        "description": "Client edited successfully."
      }
    },
    "email": "Email",
    "empty": {
      "filters": {
        "description": "Try adjusting your filters or clear them to see all clients.",
        "title": "No clients match your filters"
      },
      "noFilters": {
        "description": "Once a client books a trip, they will appear here.",
        "title": "No clients yet"
      }
    },
    "error": {
      "description": "We encountered an error while loading clients. Please try again."
    },
    "exportPDF": {
      "all": {
        "button": "Export All",
        "empty": "No clients found to export.",
        "error": {
          "description": "Could not export clients to PDF. Please try again."
        },
        "success": {
          "description": "All clients exported to PDF successfully."
        }
      },
      "button": "Export to PDF",
      "error": {
        "description": "Could not export client to PDF. Please try again."
      },
      "success": {
        "description": "Client exported to PDF successfully."
      }
    },
    "filters": {
      "lastTripDate": "Last Trip Date",
      "tags": "Tags",
      "totalBookings": "Total Bookings",
      "totalSpent": "Total Spent"
    },
    "firstTripDate": "First trip",
    "forbidden": {
      "description": "You are not allowed to view clients. Contact your administrator if you think this is an error."
    },
    "lastTripDate": "Last trip",
    "name": "Name",
    "nationalId": {
      "available": "Available",
      "back": "Back",
      "front": "Front",
      "notAvailable": "Not available",
      "status": "Status",
      "title": "National ID",
      "unlock": "Unlock",
      "vaultLocked": "Vault is locked",
      "view": "View"
    },
    "new": "New client",
    "notes": "Notes",
    "phone": "Phone number",
    "registered": "Registered",
    "save": "Save client",
    "search": {
      "placeholder": "Search by name or phone number..."
    },
    "sort": {
      "createdAt_asc": "Oldest first trip",
      "createdAt_desc": "Newest first trip",
      "lastTripDate_asc": "Oldest last trip",
      "lastTripDate_desc": "Newest last trip",
      "name_asc": "Name (A-Z)",
      "name_desc": "Name (Z-A)",
      "phone_asc": "Phone number (A-Z)",
      "phone_desc": "Phone number (Z-A)",
      "totalBookings_asc": "Least bookings",
      "totalBookings_desc": "Most bookings",
      "totalSpent_asc": "Lowest spend",
      "totalSpent_desc": "Highest spend"
    },
    "tags": "Tags",
    "totalAmountDue": "Total amount due",
    "totalBookings": "Bookings",
    "totalSpent": "Spent",
    "view": "View client",
    "yourClients": "Your Clients"
  },
  "close": "Close",
  "comma": ", ",
  "confirm": "Confirm",
  "continue": "Continue",
  "copy": {
    "code": "Copy code",
    "copied": "Copied!",
    "id": "Copy ID",
    "link": "Copy link"
  },
  "date": {
    "date": "Date",
    "end": "End date",
    "select": "Select a date",
    "start": "Start date"
  },
  "day_few": "{{count}} days",
  "day_many": "{{count}} days",
  "day_one": "1 day",
  "day_other": "{{count}} days",
  "day_two": "2 days",
  "day_zero": "0 days",
  "delete": "Delete",
  "discountCode": {
    "empty": {
      "filters": {
        "description": "Try adjusting your filters or clear them to see all discount codes.",
        "title": "No discount codes match your filters"
      },
      "noFilters": {
        "description": "The discount code you're looking for doesn't exist or may have been removed.",
        "title": "Discount code not found"
      }
    },
    "error": {
      "description": "We encountered an error while loading this discount code. Please try again."
    },
    "forbidden": {
      "description": "You are not allowed to view this discount code. Contact your administrator if you think this is an error."
    },
    "new": "New discount code"
  },
  "discountCodes": {
    "FIXED": "Fixed",
    "PERCENTAGE": "Percentage",
    "allTrips": "All trips",
    "allTripsSelected": "All trips selected",
    "code": "Code",
    "codeExists": "Code already exists",
    "create": {
      "error": {
        "description": "Could not create discount code. Please try again."
      },
      "success": {
        "description": "Discount code created successfully."
      }
    },
    "createdAt": "Created at",
    "delete": {
      "confirm": {
        "description": "Are you sure you want to delete this discount code? This action cannot be undone.",
        "title": "Delete discount code"
      },
      "error": {
        "description": "Could not delete discount code. Please try again."
      },
      "success": {
        "description": "Discount code deleted successfully."
      }
    },
    "discountCode": "Discount code",
    "edit": {
      "edit": "Edit discount code",
      "error": {
        "description": "Could not edit discount code. Please try again."
      },
      "success": {
        "description": "Discount code edited successfully."
      }
    },
    "empty": {
      "filters": {
        "description": "Try adjusting your filters or clear them to see all discount codes.",
        "title": "No discount codes match your filters"
      },
      "noFilters": {
        "description": "Once a discount code is used, it will appear here.",
        "title": "No discount codes yet"
      }
    },
    "error": {
      "description": "We encountered an error while loading discount codes. Please try again."
    },
    "expiresAt": "Expires at",
    "exportPDF": {
      "all": {
        "button": "Export All",
        "empty": "No discount codes found to export.",
        "error": {
          "description": "Could not export discount codes to PDF. Please try again."
        },
        "success": {
          "description": "All discount codes exported to PDF successfully."
        }
      },
      "button": "Export to PDF",
      "error": {
        "description": "Could not export discount code to PDF. Please try again."
      },
      "success": {
        "description": "Discount code exported to PDF successfully."
      }
    },
    "filters": {
      "expiresAt": "Expires at",
      "newOnly": "New clients only",
      "no": "no",
      "notNewOnly": "Not new clients only",
      "type": "Type",
      "usageLimit": "Maximum uses",
      "value": "Value",
      "yes": "yes"
    },
    "forbidden": {
      "description": "You are not allowed to view discount codes. Contact your administrator if you think this is an error."
    },
    "new": "New discount code",
    "newOnly": "New clients only",
    "numberOfTrips": "Trips applicable",
    "numberOfUses": "Times used",
    "save": "Save discount code",
    "search": {
      "placeholder": "Search by code..."
    },
    "sort": {
      "code_asc": "Code (A–Z)",
      "code_desc": "Code (Z–A)",
      "createdAt_asc": "Oldest",
      "createdAt_desc": "Newest",
      "expiresAt_asc": "Newest expires at",
      "expiresAt_desc": "Oldest expires at",
      "newOnly_asc": "New clients only",
      "newOnly_desc": "New clients only",
      "type_asc": "Smallest value",
      "type_desc": "Largest value",
      "usageLimit_asc": "Lowest maximum uses",
      "usageLimit_desc": "Highest maximum uses"
    },
    "type": "Type",
    "usageLimit": "Maximum uses",
    "value": "Value",
    "yourDiscountCodes": "Your Discount Codes"
  },
  "edit": "Edit",
  "egp": "EGP",
  "employee": {
    "empty": {
      "filters": {
        "description": "Try adjusting your filters or clear them to see all employees.",
        "title": "No employee matches your filters"
      },
      "noFilters": {
        "description": "The employee you're looking for doesn't exist or may have been removed.",
        "title": "Employee not found"
      }
    },
    "error": {
      "description": "We encountered an error while loading this employee. Please try again."
    },
    "forbidden": {
      "description": "You are not allowed to view this employee. Contact your administrator if you think this is an error."
    },
    "new": "New employee"
  },
  "employees": {
    "active": "Active",
    "create": {
      "error": {
        "description": "Could not create employee. Please try again.",
        "roleId": "Role not found"
      },
      "success": {
        "description": "Employee created successfully."
      }
    },
    "dateJoined": "Date joined",
    "delete": {
      "confirm": {
        "description": "Are you sure you want to delete this employee? This action cannot be undone.",
        "title": "Delete employee"
      },
      "error": {
        "description": "Could not delete employee. Please try again."
      },
      "success": {
        "description": "Employee deleted successfully."
      }
    },
    "detail": {
      "employeeInfo": "Employee Information"
    },
    "edit": {
      "edit": "Edit employee",
      "error": {
        "description": "Could not edit employee. Please try again."
      },
      "success": {
        "description": "Employee edited successfully."
      }
    },
    "employees": "Employees",
    "empty": {
      "filters": {
        "description": "Try adjusting your filters or clear them to see all employees.",
        "title": "No employees match your filters"
      },
      "noFilters": {
        "description": "Add your first employee to start building your team.",
        "title": "No employees yet"
      }
    },
    "error": {
      "description": "We encountered an error while loading employees. Please try again."
    },
    "exportPDF": {
      "all": {
        "button": "Export All",
        "empty": "No employees found to export.",
        "error": {
          "description": "Could not export employees to PDF. Please try again."
        },
        "success": {
          "description": "All employees exported to PDF successfully."
        }
      },
      "button": "Export to PDF",
      "error": {
        "description": "Could not export employee to PDF. Please try again."
      },
      "success": {
        "description": "Employee exported to PDF successfully."
      }
    },
    "filters": {
      "dateJoined": "Date Joined",
      "isActive": "Status",
      "role": "Role",
      "roles": "Roles"
    },
    "forbidden": {
      "description": "You are not allowed to view employees. Contact your administrator if you think this is an error."
    },
    "inactive": "Inactive",
    "name": "Name",
    "new": "New employee",
    "password": "Password",
    "phone": "Phone number",
    "role": "Role",
    "save": "Save employee",
    "search": {
      "placeholder": "Search by name or phone number..."
    },
    "showPassword": {
      "error": {
        "description": "Could not show password. Please try again."
      }
    },
    "sort": {
      "createdAt_asc": "Oldest",
      "createdAt_desc": "Newest",
      "isActive_asc": "Inactive first",
      "isActive_desc": "Active first",
      "name_asc": "Name (A-Z)",
      "name_desc": "Name (Z-A)",
      "phone_asc": "Phone number (A-Z)",
      "phone_desc": "Phone number (Z-A)",
      "role_asc": "Role (A-Z)",
      "role_desc": "Role (Z-A)"
    },
    "status": "Status",
    "updatePassword": {
      "error": {
        "description": "Could not update password. Please try again."
      },
      "success": {
        "description": "Password updated successfully."
      },
      "updatePassword": "Update password"
    },
    "username": "Username",
    "view": "View employee",
    "yourEmployees": "Your Employees"
  },
  "empty": {
    "filters": {
      "description": "Try adjusting your filters or clear them to see all resources.",
      "title": "No resources match your filters"
    },
    "new": "New resource",
    "noFilters": {
      "description": "The resource you're looking for doesn't exist or may have been removed.",
      "title": "Resource not found"
    }
  },
  "error": {
    "description": "We encountered an error while loading this resource. Please try again.",
    "title": "Error loading resource"
  },
  "export": "Export",
  "exportPDF": "Export to PDF",
  "exporting": "Exporting...",
  "filters": {
    "all": "All",
    "apply": "Apply filters",
    "clear": "Clear filters",
    "filter": "Filter",
    "filters": "Filters",
    "search": "Search",
    "status": "Status"
  },
  "finance": {
    "breakdowns": {
      "comingSoon": "Coming soon",
      "noData": "No data available",
      "paymentStatus": "Payment status",
      "refundReasons": "Refund reasons",
      "revenueByPaymentMethod": "Revenue by payment method",
      "revenueByTrip": "Revenue by trip",
      "title": "Breakdown"
    },
    "error": {
      "description": "We encountered an error while loading finance data. Please try again."
    },
    "export": "Export",
    "exportPDF": {
      "error": {
        "description": "Could not export financial report. Please try again."
      },
      "success": {
        "description": "Financial report exported successfully."
      }
    },
    "forbidden": {
      "description": "You are not allowed to view finance data. Contact your administrator if you think this is an error."
    },
    "kpis": {
      "allTime": "All time",
      "amountDue": "Amount due",
      "amountDueTooltip": "Total outstanding balance across all reservations that clients still need to pay.",
      "availableBalance": "Available to withdraw",
      "held": "Held",
      "heldTooltip": "Money earned from customers but held temporarily for potential cancellations. Once the cancellation deadline passes, this amount becomes available to withdraw.",
      "totalEarned": "Total earned",
      "totalRefunded": "Total refunded",
      "totalRevenue": "Total revenue"
    },
    "ledger": {
      "amount": "Amount",
      "client": "Client",
      "date": "Date",
      "empty": {
        "filters": {
          "description": "Try adjusting your filters or clear them to see all tranactions.",
          "title": "No transactions match your filters"
        },
        "noFilters": {
          "description": "No payment transactions found for the selected period.",
          "title": "No transactions yet"
        }
      },
      "error": {
        "description": "We encountered an error while loading transactions. Please try again."
      },
      "forbidden": {
        "description": "You are not allowed to view transactions. Contact your administrator if you think this is an error."
      },
      "method": "Method",
      "new": "New transaction",
      "reservation": "Reservation",
      "search": {
        "placeholder": "Search transactions..."
      },
      "status": "Status",
      "statuses": {
        "CAPTURED": "Completed",
        "FAILED": "Failed",
        "PENDING": "Pending",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "title": "Payment Transactions",
      "trip": "Trip",
      "type": "Type",
      "types": {
        "AUTH": "Authorization",
        "CAPTURE": "Capture",
        "PAYMENT": "Payment",
        "REFUND": "Refund",
        "VOID": "Void"
      }
    },
    "title": "Finances",
    "trends": {
      "amount": "Amount",
      "paymentsOverTime": "Payments over time",
      "refundsOverTime": "Refunds over time",
      "title": "Trends"
    },
    "withdraw": {
      "amount": "Amount",
      "amountExceedsBalance": "Amount exceeds available balance",
      "availableBalance": "Available to withdraw",
      "bankCardNumber": "Bank card number",
      "bankCode": "Bank",
      "bankTransactionType": "Transaction type",
      "button": "Withdraw",
      "error": {
        "description": "Could not process withdrawal. Please try again."
      },
      "fullName": "Full name",
      "issuers": {
        "BANK_CARD": "Bank card",
        "BANK_WALLET": "Bank wallet",
        "ETISALAT": "Etisalat",
        "INSTANT_BANK": "Instant bank",
        "MOBILE_WALLET": "Mobile wallet",
        "POST": "Egypt Post",
        "ORANGE": "Orange",
        "VODAFONE": "Vodafone"
      },
      "method": "Withdrawal method",
      "nationalId": "National ID",
      "phone": "Phone number",
      "saveMethod": "Save this method for future withdrawals",
      "submit": "Withdraw",
      "success": {
        "description": "Your withdrawal request has been submitted successfully.",
        "title": "Withdrawal initiated"
      },
      "title": "Withdraw funds",
      "transactionTypes": {
        "CASH_TRANSFER": "Cash transfer",
        "CREDIT_CARD": "Credit card",
        "PREPAID_CARD": "Prepaid card",
        "SALARY": "Salary"
      }
    },
    "withdrawals": {
      "amount": "Amount",
      "date": "Date",
      "description": "Description",
      "empty": {
        "filters": {
          "description": "Try adjusting your filters or clear them to see all withdrawals.",
          "title": "No withdrawals match your filters"
        },
        "noFilters": {
          "description": "Your withdrawal history will appear here once you make a withdrawal.",
          "title": "No withdrawals yet"
        }
      },
      "error": {
        "description": "We encountered an error while loading withdrawals. Please try again."
      },
      "forbidden": {
        "description": "You are not allowed to view withdrawals. Contact your administrator if you think this is an error."
      },
      "method": "Method",
      "nationalId": "National ID",
      "number": "Number",
      "status": "Status",
      "statuses": {
        "COMPLETED": "Completed",
        "FAILED": "Failed",
        "PENDING": "Pending"
      },
      "title": "Withdrawal History"
    }
  },
  "forbidden": {
    "description": {
      "action": "You are not allowed to perform this action. Contact your administrator if you think this is an error.",
      "resource": "You are not allowed to access this resource. Contact your administrator if you think this is an error."
    },
    "title": "Access denied"
  },
  "home": {
    "reservations": {
      "title": "New reservations"
    },
    "title": "Hello, {{name}}",
    "trips": {
      "upcoming": {
        "title": "Upcoming trips"
      }
    }
  },
  "loadMore": "Load more",
  "login": {
    "continueWithGoogle": "Continue with Google",
    "description": "Sign in to manage your agency",
    "login": "Login",
    "noAccount": "Don't have an account?",
    "password": "Password",
    "register": "Register",
    "rememberMe": "Keep me logged in",
    "title": "Welcome Back",
    "username": "Username"
  },
  "logout": "Logout",
  "maximum": "Maximum",
  "menu": "Menu",
  "minimum": "Minimum",
  "no": "No",
  "noOptions": "No options found",
  "noResults": "No results found",
  "nom": "No.",
  "none": "None",
  "notFound": {
    "description": "The resource you are looking for does not exist or may have been removed.",
    "title": "Not found"
  },
  "onboarding": {
    "vaultPassword": {
      "confirmPassword": "Confirm vault password",
      "description": "The agency-wide vault password is used to encrypt and protect sensitive information such as your national ID data. Please choose a strong password and keep it secure.",
      "descriptionHighlighted": "This password won't be used to login, you can change it later in the settings.",
      "password": "Vault password",
      "title": "Set Vault Password"
    }
  },
  "options": "Options",
  "overview": "Overview",
  "payments": {
    "edit": "Edit payment",
    "empty": {
      "filters": {
        "description": "Try adjusting your filters or clear them to see all payments.",
        "title": "No payments match your filters"
      },
      "noFilters": {
        "description": "Payments from this reservation will appear here once they are created.",
        "title": "No payments yet"
      }
    },
    "error": {
      "description": "We encountered an error while loading payments. Please try again."
    },
    "forbidden": {
      "description": "You are not allowed to view payments. Contact your administrator if you think this is an error."
    },
    "new": "New payment",
    "update": {
      "error": {
        "description": "Could not update payment. Please try again."
      },
      "success": {
        "description": "Payment updated successfully."
      }
    },
    "void": "Void payment",
    "voidPayment": {
      "error": {
        "description": "Could not void payment. Please try again."
      },
      "success": {
        "description": "Payment voided successfully."
      }
    }
  },
  "pdf": {
    "auditLog": {
      "dateRange": "Date range:",
      "entries": "Entries",
      "noEntriesFound": "No audit log entries found",
      "summary": "Summary",
      "title": "Audit Log",
      "totalEntries": "Total entries:"
    },
    "clients": {
      "amountDue": "Amount due:",
      "clientInformation": "Client Information",
      "clientNationalId": "Client National ID",
      "email": "Email:",
      "firstTripDate": "First trip date:",
      "lastTripDate": "Last trip date:",
      "notes": "Notes:",
      "phoneNumber": "Phone number:",
      "statistics": "Statistics",
      "tags": "Tags:",
      "title": "Client Record",
      "totalBookings": "Total bookings:",
      "totalSpent": "Total spent:"
    },
    "common": {
      "action": "Action",
      "adults": "Adults",
      "amount": "Amount",
      "children": "Children",
      "client": "Client",
      "date": "Date",
      "id": "ID",
      "method": "Method",
      "model": "Model",
      "name": "Name:",
      "no": "No",
      "number": "#",
      "permission": "permission",
      "permissions": "permissions",
      "qty": "Qty",
      "refund": "(Refund)",
      "reservation": "Reservation",
      "resource": "Resource",
      "serialNumber": "Serial number:",
      "status": "Status:",
      "total": "Total",
      "trip": "Trip",
      "unitPrice": "Unit price",
      "user": "User",
      "yes": "Yes"
    },
    "discountCodes": {
      "code": "Code:",
      "createdAt": "Created at:",
      "expiresAt": "Expires at:",
      "information": "Information",
      "newOnly": "New clients only:",
      "statistics": "Statistics",
      "title": "Discount Code Record",
      "totalReservations": "Total reservations:",
      "totalRevenue": "Total revenue:",
      "type": "Type:",
      "usageLimit": "Usage limit:",
      "value": "Value:"
    },
    "employees": {
      "dateJoined": "Date joined:",
      "employeeInformation": "Employee Information",
      "permissions": "Permissions:",
      "permissionsSection": "Permissions",
      "phoneNumber": "Phone number:",
      "roleInformation": "Role Information",
      "roleName": "Role name:",
      "title": "Employee Record",
      "username": "Username:"
    },
    "finances": {
      "amountDue": "Amount due:",
      "financialOverview": "Financial Overview",
      "heldAmount": "Held amount:",
      "netAmount": "Net amount:",
      "noPaymentsFound": "No payments found",
      "paymentLedger": "Payment Ledger",
      "reservation": "Reservation",
      "title": "Financial Report",
      "totalPayments": "Total payments:",
      "totalRefunded": "Total refunded:",
      "totalRefunds": "Total refunds:",
      "totalRevenue": "Total revenue:"
    },
    "reservations": {
      "adult": "Adult",
      "amountDue": "Amount due:",
      "amountRefunded": "Amount refunded:",
      "cancelledAt": "Cancelled at:",
      "child": "Child",
      "clientInformation": "Client Information",
      "clientNationalId": "Client National ID",
      "createdAt": "Created at:",
      "createdById": "Created by (ID):",
      "currentStatus": "Current status:",
      "financialBreakdown": "Financial Breakdown",
      "item": "Item",
      "payments": "Payments",
      "refundDue": "Refund due:",
      "reservationInformation": "Reservation Information",
      "reservationPolicy": "Reservation Policy",
      "title": "Internal Reservation Record",
      "totalPaid": "Total paid:",
      "totalPrice": "Total price:",
      "totalRefundable": "Total refundable:",
      "tripInformation": "Trip Information"
    },
    "roles": {
      "createdAt": "Created at:",
      "numberOfEmployees": "Number of employees:",
      "numberOfPermissions": "Number of permissions:",
      "permissions": "Permissions",
      "roleInformation": "Role Information",
      "roleName": "Role name:",
      "title": "Role Record",
      "updatedAt": "Updated at:"
    },
    "trips": {
      "accessibility": "Accessibility:",
      "adultCancellationFee": "Adult cancellation fee:",
      "adultPrice": "Adult price:",
      "adultPriceColumn": "Adult price",
      "adultReservationFee": "Adult reservation fee:",
      "amountDue": "Amount due:",
      "audience": "Audience:",
      "cancellationAllowed": "Cancellation allowed:",
      "cancellationDeadline": "Cancellation deadline:",
      "cancellationPolicy": "Cancellation Policy",
      "childCancellationFee": "Child cancellation fee:",
      "childMaximumAge": "Child maximum age:",
      "childPrice": "Child price:",
      "childPriceColumn": "Child price",
      "childReservationFee": "Child reservation fee:",
      "currentReservations": "Current reservations:",
      "currentRevenue": "Current revenue:",
      "food": "Food:",
      "groupPricing": "Group pricing",
      "guides": "Guides:",
      "hotelInformation": "Hotel Information",
      "hotelLocation": "Hotel location:",
      "hotelName": "Hotel name:",
      "locations": "Locations:",
      "maxCapacity": "Max capacity:",
      "minimumPeople": "Minimum people",
      "noReservationsFound": "No reservations found",
      "performance": "Performance",
      "pricing": "Pricing",
      "reservationDeadline": "Reservation deadline:",
      "reservations": "Reservations",
      "serial": "Serial",
      "tags": "Tags",
      "targetRevenue": "Target revenue:",
      "timeline": "Timeline:",
      "title": "Trip Record",
      "totalPrice": "Total Price",
      "transportation": "Transportation:",
      "tripImages": "Trip Images",
      "tripInformation": "Trip Information",
      "viewOnGoogleMaps": "View on Google Maps",
      "visible": "Visible:"
    }
  },
  "per_person_few": "per {{count}} people",
  "per_person_many": "per {{count}} people",
  "per_person_one": "per person",
  "per_person_other": "per {{count}} people",
  "per_person_two": "per 2 people",
  "per_person_zero": "per no one",
  "permissions": {
    "category": "Category",
    "create": "Create",
    "delete": "Delete",
    "get": "View",
    "modify": "Modify",
    "none": "No permissions",
    "permissions": "Permissions",
    "resources": {
      "analytics": "Analytics",
      "client": "Client",
      "discountCode": "Discount code",
      "employee": "Employee",
      "finance": "Finance",
      "nationalId": "National ID",
      "reservation": "Reservation",
      "trip": "Trip"
    },
    "update": "Edit",
    "view": "View"
  },
  "person_few": "{{count}} people",
  "person_many": "{{count}} people",
  "person_one": "1 person",
  "person_other": "{{count}} people",
  "person_two": "2 people",
  "person_zero": "0 people",
  "present": "Present",
  "remove": "Remove",
  "reservation": {
    "empty": {
      "filters": {
        "description": "Try adjusting your filters or clear them to see all reservations.",
        "new": "New reservation",
        "title": "No reservation matches your filters"
      },
      "noFilters": {
        "description": "The reservation you're looking for doesn't exist or may have been removed.",
        "title": "Reservation not found"
      }
    },
    "error": {
      "description": "We encountered an error while loading this reservation. Please try again."
    },
    "forbidden": {
      "description": "You are not allowed to view this reservation. Contact your administrator if you think this is an error."
    },
    "new": "New reservation"
  },
  "reservations": {
    "adults": "Adults",
    "all": {
      "empty": {
        "filters": {
          "description": "Try adjusting your filters or clear them to see all reservations.",
          "title": "No reservations match your filters"
        },
        "noFilters": {
          "description": "Reservations in the past 30 days will appear here.",
          "title": "No reservations yet"
        }
      },
      "new": "New reservation"
    },
    "amountDue": "Due",
    "amountPaid": "Paid",
    "amountRefunded": "Refunded",
    "cancelled": "Cancelled",
    "changeClient": "Change",
    "childReservationFee": "Child reservation fee",
    "children": "Children",
    "client": {
      "client": "Client",
      "empty": {
        "filters": {
          "description": "Try adjusting your filters or clear them to see all reservations.",
          "title": "No reservations match your filters"
        },
        "noFilters": {
          "description": "Reservations from this client will appear here once they book a trip.",
          "title": "No reservations yet"
        }
      },
      "new": "New reservation"
    },
    "clientExists": {
      "createNew": "Create new client",
      "description": "This client with this phone number already exists. Do you still want to create a new client?",
      "title": "Client already exists"
    },
    "contact": "Contact",
    "create": {
      "error": {
        "description": "Could not create your reservation. Please try again."
      },
      "success": {
        "description": "Reservation created successfully."
      }
    },
    "createdAt": "Created",
    "dateCreated": "Date created",
    "discountCode": {
      "empty": {
        "filters": {
          "description": "Try adjusting your filters or clear them to see all reservations.",
          "title": "No reservations match your filters"
        },
        "noFilters": {
          "description": "Reservations that use this discount code will appear here.",
          "title": "No reservations yet"
        }
      },
      "new": "New reservation"
    },
    "edit": {
      "cancel": {
        "confirm": {
          "button": "Cancel reservation",
          "description": "Are you sure you want to cancel this reservation? This action cannot be undone.",
          "title": "Cancel reservation"
        },
        "success": {
          "description": "Reservation cancelled successfully."
        }
      },
      "error": {
        "description": "Could not edit your reservation. Please try again."
      },
      "success": {
        "description": "Reservation edited successfully."
      }
    },
    "editReservation": "Edit reservation",
    "error": {
      "description": "We encountered an error while loading your reservations. Please try again."
    },
    "exportPDF": {
      "all": {
        "button": "Export All",
        "empty": "No reservations found to export.",
        "error": {
          "description": "Could not export reservations to PDF. Please try again."
        },
        "success": {
          "description": "All reservations exported to PDF successfully."
        }
      },
      "error": {
        "description": "Could not export reservation to PDF. Please try again."
      },
      "success": {
        "description": "Reservation exported to PDF successfully."
      },
      "title": "Export to PDF",
      "vaultLocked": {
        "description": "The vault is locked. Would you like to unlock it to include the national ID in the PDF, or export without the national ID?",
        "exportWithoutId": "Export without National ID",
        "stillLocked": "The vault is still locked. Please unlock it first.",
        "title": "Vault is Locked",
        "unlock": "Unlock Vault"
      }
    },
    "forbidden": {
      "description": "You are not allowed to view reservations. Contact your administrator if you think this is an error."
    },
    "force": {
      "description": {
        "added_few": "but you're trying to confirm {{count}} spots. Proceeding may overbook the trip.",
        "added_many": "but you're trying to confirm {{count}} spots. Proceeding may overbook the trip.",
        "added_one": "but you're trying to confirm 1 spot. Proceeding may overbook the trip.",
        "added_other": "but you're trying to confirm {{count}} spots. Proceeding may overbook the trip.",
        "added_two": "but you're trying to confirm 2 spots. Proceeding may overbook the trip.",
        "added_zero": "but you're trying to confirm 0 spots. Proceeding may overbook the trip.",
        "confirm": "Do you want to confirm anyway?",
        "left_few": "This trip only has {{count}} spots left,",
        "left_many": "This trip only has {{count}} spots left,",
        "left_one": "This trip only has 1 spot left,",
        "left_other": "This trip only has {{count}} spots left,",
        "left_two": "This trip only has 2 spots left,",
        "left_zero": "This trip has no spots left,"
      },
      "title": "Not enough spots available"
    },
    "newReservation": "New reservation",
    "payments": {
      "success": {
        "description": "Payment added successfully."
      },
      "title": "Payments"
    },
    "priceUpdated": {
      "description": "The trip price has changed. Please review and submit your reservation again.",
      "title": "Trip price updated"
    },
    "refund": "Refund",
    "refundDue": "Refund due",
    "reservation": "Reservation",
    "reservationDeadline": "Reservation deadline",
    "reservationFee": "Reservation fee",
    "reservationNumber": "Reservation number",
    "reservations": "Reservations",
    "save": "Save reservation",
    "selectClient": "Select client",
    "status": {
      "NO_REFUND": "No refund",
      "OVERPAID": "Overpaid",
      "OVERREFUNDED": "Over refunded",
      "PAYMENT": "Payment",
      "PAYMENT_COMPLETE": "Paid fully",
      "PAYMENT_PARTIAL": "Partially paid",
      "PAYMENT_PENDING": "Pending payment",
      "PAYMENT_RESERVATION": "Reservation secured",
      "REFUND": "Refund",
      "REFUND_COMPLETE": "Refunded",
      "REFUND_PARTIAL": "Partially refunded",
      "REFUND_PENDING": "Pending refund",
      "status": "Status"
    },
    "summary": "Summary",
    "totalPrice": "Total price",
    "totalRefund": "Total refund",
    "trip": {
      "empty": {
        "filters": {
          "description": "Try adjusting your filters or clear them to see all reservations.",
          "title": "No reservations match your filters"
        },
        "noFilters": {
          "description": "Reservations from clients will appear here once they book this trip.",
          "title": "No reservations yet"
        }
      },
      "new": "New reservation"
    },
    "updateAmountPaid": "Update paid",
    "updateAmountRefunded": "Update refunded"
  },
  "return": "Return",
  "returnHome": "Return home",
  "revenueProgress": "Revenue progress",
  "role": {
    "empty": {
      "filters": {
        "description": "Try adjusting your filters or clear them to see all roles.",
        "title": "No role matches your filters"
      },
      "noFilters": {
        "description": "The role you're looking for doesn't exist or may have been removed.",
        "title": "Role not found"
      }
    },
    "error": {
      "description": "We encountered an error while loading this role. Please try again."
    },
    "forbidden": {
      "description": "You are not allowed to view this role. Contact your administrator if you think this is an error."
    },
    "new": "New role"
  },
  "roles": {
    "create": {
      "error": {
        "description": "Could not create role. Please try again."
      },
      "success": {
        "description": "Role created successfully."
      }
    },
    "delete": {
      "confirm": {
        "description": "Are you sure you want to delete this role? This action cannot be undone.",
        "title": "Delete role"
      },
      "error": {
        "description": "Could not delete role. Please try again."
      },
      "success": {
        "description": "Role deleted successfully."
      }
    },
    "edit": {
      "edit": "Edit role",
      "error": {
        "description": "Could not edit role. Please try again."
      },
      "success": {
        "description": "Role edited successfully."
      }
    },
    "employees_few": "{{count}} employees",
    "employees_many": "{{count}} employees",
    "employees_one": "1 employee",
    "employees_other": "{{count}} employees",
    "employees_two": "2 employees",
    "employees_zero": "No employees",
    "empty": {
      "filters": {
        "description": "Try adjusting your filters or clear them to see all roles.",
        "title": "No roles match your filters"
      },
      "noFilters": {
        "description": "Get started by creating your first role. It only takes a few minutes!",
        "title": "No roles yet"
      }
    },
    "error": {
      "description": "We encountered an error while loading roles. Please try again."
    },
    "exportPDF": {
      "all": {
        "button": "Export All",
        "empty": "No roles found to export.",
        "error": {
          "description": "Could not export roles to PDF. Please try again."
        },
        "success": {
          "description": "All roles exported to PDF successfully."
        }
      },
      "button": "Export to PDF",
      "error": {
        "description": "Could not export role to PDF. Please try again."
      },
      "success": {
        "description": "Role exported to PDF successfully."
      }
    },
    "forbidden": {
      "description": "You are not allowed to view roles. Contact your administrator if you think this is an error."
    },
    "name": "Role name",
    "new": "New role",
    "permissions_few": "{{count}} permissions",
    "permissions_many": "{{count}} permissions",
    "permissions_one": "1 permission",
    "permissions_other": "{{count}} permissions",
    "permissions_two": "2 permissions",
    "permissions_zero": "No permissions",
    "roles": "Roles",
    "save": "Save role",
    "sort": {
      "name_asc": "Name (A-Z)",
      "name_desc": "Name (Z-A)",
      "numberOfEmployees_asc": "Least employees",
      "numberOfEmployees_desc": "Most employees",
      "numberOfPermissions_asc": "Least permissions",
      "numberOfPermissions_desc": "Most permissions"
    },
    "viewEmployees": "View employees",
    "yourRoles": "Your Roles"
  },
  "save": "Save",
  "search": "Search",
  "settings": {
    "agency": {
      "loadError": "Could not load agency information. Please try again.",
      "update": {
        "error": {
          "description": "Could not update agency information. Please try again."
        },
        "success": {
          "description": "Agency information updated successfully."
        }
      }
    },
    "general": {
      "darkMode": "Switch to Dark Mode",
      "language": "Language",
      "languageDescription": "Choose your preferred language for the interface.",
      "lightMode": "Switch to Light Mode",
      "theme": {
        "dark": "Dark mode",
        "light": "Light mode",
        "title": "Theme"
      },
      "themeDescription": "Switch between light and dark mode."
    },
    "nationalId": {
      "confirmPassword": "Confirm password",
      "deletePassword": {
        "confirm": {
          "description": "Are you sure you want to delete your national ID password? This action cannot be undone.",
          "title": "Delete Password"
        },
        "error": {
          "description": "Could not delete password. Please try again."
        },
        "success": {
          "description": "Password deleted successfully."
        },
        "title": "Delete password"
      },
      "description": "View information about your national ID vault status.",
      "lastUpdated": "Last updated",
      "lock": {
        "error": {
          "description": "Could not lock vault. Please try again."
        },
        "success": {
          "description": "Vault locked successfully"
        },
        "title": "Lock vault"
      },
      "password": "Password",
      "passwordNotSet": "Password is not set",
      "passwordSet": "Password is set",
      "passwordSetOn": "Password set on",
      "passwordStatus": "Password status",
      "setPassword": {
        "error": {
          "description": "Could not set password. Please try again."
        },
        "success": {
          "description": "Password set successfully"
        },
        "title": "Set password"
      },
      "setPasswordDescription": "Set a password to view national IDs",
      "title": "National ID Vault",
      "unlock": {
        "description": "Enter your password to unlock the vault.",
        "error": {
          "description": "The password you entered is incorrect. Please try again.",
          "incorrectPassword": "Incorrect password"
        },
        "success": {
          "description": "Vault unlocked successfully"
        },
        "title": "Unlock vault"
      },
      "vaultLocked": "Vault is locked",
      "vaultStatus": "Vault status",
      "vaultUnlocked": "Vault is unlocked"
    },
    "tabs": {
      "agency": "Agency Information",
      "general": "General",
      "nationalId": "National ID"
    },
    "title": "Settings"
  },
  "sidebar": {
    "nav": {
      "analytics": "Analytics",
      "auditLog": "Audit Log",
      "clients": "Clients",
      "discountCodes": "Discount Codes",
      "employees": "Employees",
      "finances": "Finances",
      "home": "Home",
      "roles": "Roles",
      "settings": "Settings",
      "trips": "Trips"
    }
  },
  "sort": {
    "amount_asc": "Lowest amount",
    "amount_desc": "Highest amount",
    "date_asc": "Oldest first",
    "date_desc": "Newest first",
    "sortBy": "Sort by"
  },
  "success": "Success",
  "tag_few": "{{count}} tags",
  "tag_many": "{{count}} tags",
  "tag_one": "1 tag",
  "tag_other": "{{count}} tags",
  "tag_two": "2 tags",
  "tag_zero": "0 tags",
  "tags": {
    "placeholder": "Type tag name and press enter"
  },
  "tier_few": "{{count}} tiers",
  "tier_many": "{{count}} tiers",
  "tier_one": "1 tier",
  "tier_other": "{{count}} tiers",
  "tier_two": "2 tiers",
  "tier_zero": "0 tiers",
  "trip": {
    "empty": {
      "filters": {
        "description": "Try adjusting your filters or clear them to see all available trips.",
        "title": "No trip matches your filters"
      },
      "noFilters": {
        "description": "The trip you're looking for doesn't exist or may have been removed.",
        "title": "Trip not found"
      }
    },
    "error": {
      "description": "We encountered an error while loading this trip. Please try again."
    },
    "forbidden": {
      "description": "You are not allowed to view this trip. Contact your administrator if you think this is an error."
    },
    "new": "New trip",
    "trip": "Trip"
  },
  "trip_selected_few": "{{count}} trips selected",
  "trip_selected_many": "{{count}} trips selected",
  "trip_selected_one": "1 trip selected",
  "trip_selected_other": "{{count}} trips selected",
  "trip_selected_two": "2 trips selected",
  "trip_selected_zero": "no trips selected",
  "trips": {
    "booked": "booked",
    "cancellationPolicy": {
      "allowed": "Cancellation allowed",
      "cancellationDeadline": "Cancellation deadline",
      "cancellationFee": "Cancellation fee",
      "cancellationPolicy": "Cancellation Policy",
      "childCancellationFee": "Child cancellation fee",
      "leaveEmptyForNoDeadline": "Leave empty for no deadline",
      "leaveEmptyForNoFee": "Leave empty for no fee"
    },
    "capacity": {
      "capacity": "Capacity",
      "max": "Maximum capacity"
    },
    "client": {
      "empty": {
        "filters": {
          "description": "Try adjusting your filters or clear them to see all trips.",
          "title": "No trips match your filters"
        },
        "noFilters": {
          "description": "Trips booked by this client will appear here.",
          "title": "No trips yet"
        }
      },
      "new": "New client"
    },
    "create": {
      "error": {
        "description": "Could not create your trip. Please try again.",
        "imageUpload": "Image upload failed"
      },
      "forbidden": {
        "description": "You are not allowed to create trips. Contact your administrator if you think this is an error."
      },
      "success": {
        "description": "Trip created successfully."
      }
    },
    "currentAmountDue": "Amount due",
    "delete": {
      "delete": "Delete trip"
    },
    "description": "Description",
    "discountCode": {
      "empty": {
        "filters": {
          "description": "Try adjusting your filters or clear them to see all trips.",
          "title": "No trips match your filters"
        },
        "noFilters": {
          "description": "Trips that work with this discount code will appear here.",
          "title": "No trips yet"
        }
      },
      "new": "New discount code"
    },
    "duration": "Duration",
    "edit": {
      "edit": "Edit Trip",
      "error": {
        "description": "Could not edit your trip. Please try again."
      },
      "forbidden": {
        "description": "You are not allowed to edit this trip. Contact your administrator if you think this is an error."
      },
      "success": {
        "description": "Trip edited successfully."
      }
    },
    "error": {
      "description": "We encountered an error while loading your trips. Please try again."
    },
    "exportPDF": {
      "all": {
        "button": "Export All",
        "empty": "No trips found to export.",
        "error": {
          "description": "Could not export trips to PDF. Please try again."
        },
        "success": {
          "description": "All trips exported to PDF successfully."
        }
      },
      "button": "Export to PDF",
      "error": {
        "description": "Could not export trip to PDF. Please try again."
      },
      "success": {
        "description": "Trip exported to PDF successfully."
      }
    },
    "forbidden": {
      "description": "You are not allowed to view trips. Contact your administrator if you think this is an error."
    },
    "generalInformation": "General Information",
    "hotel": {
      "hotel": "Hotel",
      "location": {
        "location": "Hotel location",
        "placeholder": "Google Maps link"
      },
      "name": {
        "name": "Hotel name",
        "placeholder": "Leave empty if no hotel"
      }
    },
    "id": "ID",
    "images": {
      "error": {
        "invalidType": {
          "description": "Please select only image files",
          "title": "Invalid file type"
        }
      },
      "new": {
        "description": "Attach as many files as you like, each file should not exceed 10MB",
        "title": "Drag images here or click to select files"
      },
      "title": "Images"
    },
    "locations": {
      "add": "Add location",
      "locations": "Locations",
      "pickValue": "Pick value",
      "create": "Create {{location}}",
      "customSearch": "Search custom locations...",
      "search": "Search locations...",
      "unknownLocation": {
        "description": "Please update your trip to fix this issue.",
        "title": "Unknown location"
      }
    },
    "name": "Name",
    "new": "New Trip",
    "noChangeAfterCreate": "Can't be changed after the trip is created",
    "noChangeAfterPublish": "Can't be changed after the trip is published",
    "occupancy": "Occupancy",
    "performance": "Performance",
    "pricing": {
      "addGroupPricing": "Add group pricing",
      "childPrice": "Child price",
      "differentChildPrice": "Different price for children",
      "groupPricing": "Group pricing",
      "maxChildDescription": "Update the maximum age for child price to enable this field",
      "maximumAgeForChildPrice": "Maximum age for child price",
      "minimumNumberOfPeople": "Minimum number of people",
      "noGroupPricingAdded": "No group pricing added",
      "perPerson": "per person",
      "price": "Price",
      "pricing": "Pricing",
      "startingPrice": "Starting price"
    },
    "revenue": "Revenue",
    "save": "Save trip",
    "saveAsDraft": "Save as draft",
    "search": {
      "placeholder": "Search for a trip"
    },
    "selectLocation": "Select a location",
    "selectTrip": "Select trip",
    "selectTrips": "Select trips",
    "serial": "Serial",
    "sort": {
      "currentReservations_asc": "Most reservations",
      "currentReservations_desc": "Least reservations",
      "currentRevenue_asc": "Highest revenue",
      "currentRevenue_desc": "Lowest revenue",
      "price_asc": "Highest price",
      "price_desc": "Lowest price",
      "startDate_asc": "Oldest",
      "startDate_desc": "Newest"
    },
    "startsIn": "Starts in",
    "status": {
      "COMPLETED": "Completed",
      "ONGOING": "Ongoing",
      "UPCOMING": "Upcoming",
      "status": "Status"
    },
    "tags": {
      "accessibility": "Accessibility",
      "adults": {
        "18": "Adults only (18+)",
        "21": "Adults only (21+)"
      },
      "airportPickup": "Airport pickup",
      "allInclusive": "All-inclusive",
      "audience": "Audience",
      "breakfastIncluded": "Breakfast included",
      "englishSpeakingGuide": "English speaking guide",
      "familyFriendly": "Family-friendly",
      "food": "Food",
      "freeParking": "Free parking",
      "freeWiFi": "Free Wi-Fi",
      "guidedTour": "Guided tour",
      "guides": "Guides",
      "halfBoard": "Half board",
      "noFood": "None",
      "petFriendly": "Pet-friendly",
      "tags": "Tags",
      "transportation": "Transportation",
      "transportationProvided": "Transportation provided",
      "wheelchairAccessible": "Wheelchair accessible"
    },
    "targetRevenue": "Target revenue",
    "timeline": "Timeline",
    "toggleVisibility": {
      "error": {
        "description": "Could not update your trip. Please try again."
      },
      "publish": {
        "success": {
          "description": "Trip published sucessfully"
        },
        "title": "Publish"
      },
      "unpublish": {
        "modal": {
          "description": "Unpublished trips are still visible to clients who have a reservation. Are you sure you want to unpublish this trip?",
          "title": "Unpublish Trip"
        },
        "success": {
          "description": "Trip unpublished successfully"
        },
        "title": "Unpublish"
      }
    },
    "trip": {
      "empty": {
        "filters": {
          "description": "Try adjusting your filters or clear them to see all trips.",
          "title": "No trips match your filters"
        },
        "noFilters": {
          "description": "Get started by creating your first trip. It only takes a few minutes!",
          "title": "No trips yet"
        }
      },
      "new": "New trip"
    },
    "trips": "Trips",
    "view": "View trip",
    "visibility": {
      "all": "All",
      "draft": "Draft",
      "draftAlert": {
        "description": "This trip is still a draft and is not published. Only clients with reservations will be able to see it."
      },
      "published": "Published",
      "visibility": "Visibility"
    },
    "yourTrips": "Your Trips"
  },
  "tryAgain": "Try again",
  "unknownError": "Unknown error",
  "unlimited": "Unlimited",
  "unsavedChanges": {
    "description": "You have unsaved changes. Are you sure you want to close this form?",
    "title": "Unsaved Changes"
  },
  "withdrawal": {
    "empty": {
      "filters": {
        "description": "Try adjusting your filters or clear them to see all withdrawals.",
        "title": "No withdrawals match your filters"
      },
      "noFilters": {
        "description": "No withdrawals found for the selected period.",
        "title": "No withdrawals yet"
      }
    },
    "error": {
      "description": "We encountered an error while loading withdrawals. Please try again."
    },
    "forbidden": {
      "description": "You are not allowed to view withdrawals. Contact your administrator if you think this is an error."
    },
    "new": "New withdrawal",
    "title": "Withdrawals"
  },
  "withdrawals": {
    "empty": {
      "filters": {
        "description": "Try adjusting your filters or clear them to see all withdrawals.",
        "title": "No withdrawals match your filters"
      },
      "noFilters": {
        "description": "No withdrawals found for the selected period.",
        "title": "No withdrawals yet"
      }
    },
    "error": {
      "description": "We encountered an error while loading withdrawals. Please try again."
    },
    "forbidden": {
      "description": "You are not allowed to view withdrawals. Contact your administrator if you think this is an error."
    },
    "new": "New withdrawal",
    "title": "Withdrawals"
  },
  "years_or_younger_few": "{{count}} yrs or younger",
  "years_or_younger_many": "{{count}} yrs or younger",
  "years_or_younger_one": "1 year or younger",
  "years_or_younger_other": "{{count}} years or younger",
  "years_or_younger_two": "2 years or younger",
  "years_or_younger_zero": "0 years or younger",
  "yes": "Yes"
}
